import { api } from "./api";

export const listarEdicoes = () => api.get("/edicao/listar");
export const obterEdicao = (id) => api.get(`/edicao/${id}`);
export const salvarEdicao = (dto) => api.post("/edicao/salvar", dto);
export const excluirEdicao = (id) => api.post(`/edicao/excluir/${id}`);

export const linkInscricao = (token) =>
  `${window.location.origin}/inscricao/${token}`;
